import data from './elements.json';

const targetDate = new Date("June 16, 2025 21:00:00 GMT+0200").getTime();
const getCurrentDate = () => Date.now();

const shouldExcludeFirstFour = getCurrentDate() > targetDate;

// Slice the data accordingly
const itemsToRender = shouldExcludeFirstFour
  ? data.carouselItems
  : data.carouselItems.slice(4)

export default `
    <div class="carousel-track" data-glide-el="track">
    <div class="carousel-slides">
      ${itemsToRender.map(item => `
        <div data-year="${item.year}">
          <a class="carousel-cta" href="${item.link}" rel="noopener noreferrer" target="_blank">
            <img draggable="false" class="preloaded" src="${item.thumbnail}" width="326" height="244" alt="" />
            <span class="info-wrap">
              <span class="info">
                <strong class="title">${item.title.replace(/\n/g, "<br>")}</strong>
                <span class="subtitle">${item.subtitle}</span>
                <ul class="credits">
                  ${item.credits.map(name => `<li>${name}</li>`).join("")}
                </ul>
              </span>
            </span>
          </a>
        </div>
      `).join("")}
    </div>
  </div>
`;
